module.exports = __webpack_public_path__ + "static/media/md.63bbfb2e.svg";